import { type HTMLAttributes } from "react";
import { APP_MAIN_SECTION_PADDING } from "@/lib/appLayoutClasses";

export interface PageContainerProps extends HTMLAttributes<HTMLDivElement> {
  /** Max width: "responsive" (default) scales with viewport; use "full" for no max. */
  maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "4xl" | "responsive" | "full";
}

const maxWidthClasses: Record<PageContainerProps["maxWidth"] & string, string> = {
  sm: "max-w-screen-sm",
  md: "max-w-screen-md",
  lg: "max-w-screen-lg",
  xl: "max-w-screen-xl",
  "2xl": "max-w-screen-2xl",
  "4xl": "max-w-4xl",
  responsive: "max-w-4xl md:max-w-5xl lg:max-w-6xl xl:max-w-7xl",
  full: "max-w-full",
};

export function PageContainer({
  maxWidth = "responsive",
  className = "",
  ...props
}: PageContainerProps) {
  return (
    <div
      className={
        `mx-auto w-full ${APP_MAIN_SECTION_PADDING} ` +
        maxWidthClasses[maxWidth] +
        (className ? " " + className : "")
      }
      {...props}
    />
  );
}
